import React from 'react';
import NavbarComponent from '../pages/Navbar';
import Footer from '../Footer';
import CommitmentSection from "../CommitmentSection";
import EventProductionBanner from './EventProductionBanner';
import EventProductionInfo from './EventProductionInfo';

const EventProductionDetails = () => {
  return (
    <>
      <NavbarComponent />
      <EventProductionBanner/>
      <CommitmentSection />
      <EventProductionInfo/>
      <Footer />
    </>
  );
};

export default EventProductionDetails;
